/* eslint-disable complexity */
import { View } from '@/domain/mitarbeiter/features/rotationsplan/entities/views';
import { useNavigate, useParams } from 'react-router-dom';
import { useStandortgruppe } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useStandortgruppen/useRotationsplanAktiviert';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import dayjs from '@/domain/mitarbeiter/shared/utils/dayjs';
import { DesktopPage } from '@/domain/mitarbeiter/pages/rotationsplan/DesktopPage';
import { MobilePage } from '@/domain/mitarbeiter/pages/rotationsplan/MobilePage';

const NavigateToV1 = () => {
  useEffect(() => {
    window.location.replace(managerV1BaseUrl);
  }, []);
  return <></>;
};

function validateRouteParam(view: string): boolean {
  const validViews: View[] = ['planung', 'rotationsplaene'];
  return validViews.includes(view as View);
}

export function Page() {
  const { t } = useTranslation();
  const { currentStandort } = useStandortContext();
  const { standortGruppe } = useStandortgruppe(
    currentStandort.idStandortgruppe,
  );
  const { view, year } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if ((!view || !validateRouteParam(view)) && !year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/planung`, {
        replace: true,
      });
    } else if (!view || !validateRouteParam(view)) {
      navigate(`/mitarbeiter/rotationsplan/${year}/planung`, {
        replace: true,
      });
    } else if (!year) {
      const currentYear = dayjs(new Date()).get('year');
      navigate(`/mitarbeiter/rotationsplan/${currentYear}/${view}`, {
        replace: true,
      });
    }
  }, [navigate, view, year]);

  if (!standortGruppe || !standortGruppe.istRotationsplanAktiviert) {
    return <NavigateToV1 />;
  }

  return (
    <>
      <Helmet>
        <title>{t('domain.mitarbeiter.rotationsplan.title')}</title>
      </Helmet>
      <div className="hidden md:block md:flex-col md:gap-8 md:p-4 md:w-screen lg:p-10 2xl:max-w-screen-2xl 2xl:mx-auto">
        <DesktopPage year={year} view={view} />
      </div>

      <div className="block md:hidden">
        <MobilePage year={year} view={view} />
      </div>
    </>
  );
}
